import { gql, useQuery } from '@apollo/client';
import { ContactFormEntityType } from './types';

export const userFieldDefinitionFields = gql`
  fragment ContactFormUserFieldDefinitionFields on UserFieldDefinition {
    id
    name
    index
    description
    ownerType
    dataType
    options
    visible
    visibleOnExpressBook
    visibleOnGuestPortal
    visibleOnQuestionnaire
    required
    systemManaged
    userFieldKey
    displayOnInternalDocs
    displayOnExternalDocs
    entityType
    entityId
  }
`;

export const contactFormVenueFields = gql`
  fragment ContactFormVenueFields on ContactFormVenue {
    id
    name
    eventStartOffset
    eventEndOffset
    minGroupSize
    multiDayEnabled
    publicApiKey
    featureScope {
      premiumFeaturesEnabled
    }
  }
`;

export const contactFormSettingsFields = gql`
  fragment ContactFormSettingsFields on ContactFormSettings {
    id
    entityId
    entityType
    backgroundColor
    buttonColor
    banner
    logo
    showVenueSelector
    availableVenues {
      id
      ...ContactFormVenueFields
    }
    redirectUrl
    widgetInstanceId
    gtmId
    helloLeadFormPath
    helloLeadFormUrl
    qrCodePngUrl
    slug
    name
    canEmbedWidget
    organizationId
    premiumFeaturesEnabled
    enterpriseFeaturesEnabled
    showPvBranding
    userFieldDefinitions {
      id
      ...ContactFormUserFieldDefinitionFields
    }
  }
  ${userFieldDefinitionFields}
  ${contactFormVenueFields}
`;

export const contactFormSettingsQuery = gql`
  query ContactFormSettings(
    $entityId: String!
    $entityType: ContactFormEntity!
  ) {
    contactFormSettings(entityId: $entityId, entityType: $entityType) {
      id
      ...ContactFormSettingsFields
    }
  }
  ${contactFormSettingsFields}
`;

export const useContactFormSettingsQuery = (
  entityId: String,
  entityType: ContactFormEntityType
) => {
  const { data, loading, error } = useQuery(contactFormSettingsQuery, {
    variables: {
      entityId,
      entityType,
    },
    skip: !entityId || !entityType,
  });
  return {
    settings: data?.contactFormSettings,
    data,
    loading,
    error,
  };
};
